<template>
<div 
  @click="$emit('onFoodCardMinClick')"
  style="border:1px solid #ddd;border-radius:10px;padding:5px 10px;background: #fff;"
>
  <v-layout row wrap>
    <v-flex xs10>
      <v-flex v-if="label" xs12 class="formElementLabel">{{label}}</v-flex>
      <v-flex v-else xs12 class="formElementLabel">カラログした食品</v-flex>
      <v-layout row wrap>
        <v-flex xs4 flat style="margin: 1px 0;">
          <v-avatar tile size="65">
            <v-img :src="imageurl" :alt="name" :lazy-src="require('@/assets/img/icon_loader.gif')"/>
          </v-avatar>
        </v-flex>
        <v-flex xs8 style="text-align:left;padding-top:8px;">
          {{name}}
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs2 style="text-align:center;padding-top:10px;">
      <v-btn icon small class="primary--text"><v-icon>launch</v-icon></v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  name: 'FoodCardMin',
  props: {
    imageurl: String,
    name: String,
    label: String,
    mode: {
      type: String,
      default: 'normal'
    }
  }
}
</script>

<style scoped>
.formElementLabel {
  text-align: left;
  color:#888;
}
</style>